import { PlaceholderThumbnail } from '@ukpostbox/frontend-framework/lib/Components/Images/Thumbnails/PlaceholderThumbnail';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage';
import React from 'react';
import { MailItemNoThumbnailType, MailPartTypeEnum } from '../Types/ThumbnailTypes';

function MailItemNoThumbnail(props: MailItemNoThumbnailType) {
	return (
		<PlaceholderThumbnail
			size={props.size}
			icon={props.mailType === MailPartTypeEnum['Mail-Envelopes'] ? faEnvelope : faImage}
		/>
	);
}

export { MailItemNoThumbnail };
